import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import HeroSection from './components/HeroSlider';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './pages/About';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Ourfleet from './pages/Ourfleets';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Enquiry from './pages/Enquiry';
import Packages from './pages/Packages';
import Service from './pages/Service';
import Punetomumbaicarrental from './pages/Pune To Mumbai Car Rental';
import Punetoshirdicabbooking from './pages/Pune to Shirdi Cab Booking';
import ScrollToTop from './components/ScrollToTop';
import Punetomahbaleshwer from './pages/Pune to Mahabaleshwar Cab';
import Punetolonavala from './pages/Pune to Lonavala - Khandala Cab';
import Punetomumbaiairporttaxi from './pages/Pune To Mumbai Airport Taxi';
import Punetoadbabsimagicacab from './pages/Pune To Adlabs Imagica Cab Booking';
import Bestcabservice from './pages/Best Cab Service For Matheran';
import Punetoganpatipule from './pages/Pune To Ganpatipule Cab Booking';
import Punetopandharpur from './pages/Pune To Pandharpur Cab Booking';
import Punetojyotilingatourpackages from './pages/Pune To Jyotirlinga Tour Package';
import Punetoashtavinayak from './pages/Pune To Ashtavinayak Darshan Cab';
import Bestcabfrompune from './pages/Best Cab From Pune To Murud Janjira';
import Punetoalibaugcab from './pages/Pune To Alibaug Affordable Cab';
import Punetoajantaellora from './pages/Pune To Ajanta Ellora Cab';
import PunetoAurangabadcabbooking from './pages/Pune To Aurangabad Cab Booking';
import Punetosaneteenshaktipeeth from './pages/Pune To Sade Teen Shakti Peeth Cab';
import Punetobhimashankarround from './pages/Pune To Bhimashankar Round Trip';
import Punetrimbeshkerbest from './pages/Pune Trimbakeshwar Best Cab';
import Punetonashikandlgatpuri from './pages/Pune To Nashik And Igatpuri Cab';
import Punetokolhapurcab from './pages/Pune To Kolhapur Cab Booking';
import Punetosataracabbooking from './pages/Pune To Satara Cab Booking';
import Punetotarkali from './pages/Pune To Tarkarli - Malvan Cab';
import Punetooutstationcab from './pages/Pune To Outstation Cab';
import Punetogoacab from './pages/Pune To Goa Cab Booking';
import Punetotuljapur from './pages/Pune To Tuljapur Cab';
import Punetoalandidehu from './pages/Pune To Alandi - Dehu Darshan Cab';
import Punetowaipanchgani from './pages/Pune To Wai - Panchgani';
import Punetosaptara from './pages/Pune To Saputara Cab Booking';
import Punetonagpurcab from './pages/Pune To Nagpur Cab';
import Punetojalanacab from './pages/Pune To Jalana Cab';
import Punecabservice from './pages/Pune Cabs Service';
import Punetaxihire from './pages/Pune Taxi Hire';
import Puneonlinecabbooking from './pages/Pune Online Cab Booking';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Punetonashikcabs from './pages/Pune to Nasik Cabs';
import Punetomahabaleshwer from './pages/Pune to Mahabaleshwar Cabs';
import Punetolonavalacabs from './pages/Pune to Lonavala Cabs';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Punetoshirdicabpackage from './pages/Pune to Shirdi Cab Package';
import Punetoajantaellorapackage from './pages/Pune to Ajanta Ellora Tour Package';
import Shirdidarshanpackage from './pages/Shirdi Darshan Package';
import Puneairporttoshirdicab from './pages/Pune Airport to Shirdi Cab';
import Punetoshirdiertigacabs from './pages/Pune to Shirdi Ertiga Cab';
import Punetoshirdiinnovacrysta from './pages/Pune to Shirdi Innova Crysta Cab';
import Pumetolavasacity from './pages/Pune to Lavasa city cabs';
import Punetobhimashankarcab from './pages/Pune to Bhimashankar Cab';
import Punetoindorecabs from './pages/Pune to Indore Cabs';
import Punetokonkandarshan from './pages/Pune to Konkan Darshan Cabs';
import Punecabfare from './pages/Pune Cab Fare';
import Puneoutstationcabs from './pages/Pune Outstation Cabs';
import Punetopanchgani from './pages/Pune to Panchgani Cab Fare';
import Punetomumbaiinternationalairport from './pages/Pune to Mumbai International Airport Cab';
import Ashtavinayakdarshancab from './pages/Ashtavinayak Darshan Cab';
import Punetogoacabs from './pages/Pune to Goa Cabs';
import Puneairportcabs from './pages/Pune Airport Cabs';
import Punetokolhapur from './pages/Pune to Kolhapur Cab';
import Tempotravelleronrentinpune from './pages/Tempo Traveller On Rent in Pune';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Punelocalcabservice from './pages/PUNE LOCAL CAB SERVICE';
import Vimannagarpunetaxi from './pages/Viman Nagar Pune Taxi';
import Punetomumbaicabs from './pages/Pune to Mumbai Cabs';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab';
import Punetomumbaionewaycab from './pages/Pune to Mumbai One Way Cab';
import Punetomumbaicarhire from './pages/Pune Mumbai Car Hire';
import Punetomumbaitaxifare from './pages/Pune to Mumbai Taxi Fare';
import Punetomumbaionlinecab from './pages/Pune to Mumbai Online Cab Booking';
import Pimprichichwadtomumbaicab from './pages/Pimpri Chinchwad to Mumbai Cab';
import Banertomumbaicabs from './pages/Baner to Mumbai Cabs';
import Hinjewaditomumbaicab from './pages/Hinjewadi to Mumbai Cab';
import Pimplesaudagartomumbaicab from './pages/Pimple Saudagar to Mumbai Cab Service';
import Wakadtomumbaicab from './pages/Wakad to Mumbai Cab';
import Hadapsartomumbaicab from './pages/Hadapsar to Mumbai Cab';
import Kalyaninagartomumbai from './pages/Kalyani Nagar to Mumbai Taxi';
import Koregaonparktomumbaicab from './pages/Koregaon Park to Mumbai Cab';
import Kothrudtomumbaicab from './pages/Kothrud to Mumbai Cab';
import Kharaditomumbaicab from './pages/Kharadi to Mumbai Cab';
import Shivajinagartomumbaicab from './pages/Shivajinagar to Mumbai Cab';
import Punetomumbaiertigacab from './pages/Pune to Mumbai Ertiga Cab';
import Punetomumbaiinnovacrysta from './pages/Pune to Mumbai Innova Crysta Cab';
import Punetomumbaisedancab from './pages/Pune to Mumbai Sedan Cab';
import Konshwatomumbaicab from './pages/Kondhwa to Mumbai Cab';
import Vimannagartomumbaicabs from './pages/Viman Nagar to Mumbai Cabs';
import Katrajtomumbaicabservice from './pages/Katraj to Mumbai Cab Service';
import Punestationtomumbaicabsservice from './pages/Pune Station to Mumbai Cabs Service';
import Boatclubroadtomumbai from './pages/Boat Club Road to Mumbai Cab';
import Vishrantwaditomumbaicab from './pages/Vishrantwadi to Mumbai Cab';
import Alanditomumbaicabs from './pages/Alandi to Mumbai Cabs Service';
import Wagholitomumbaicab from './pages/Wagholi to Mumbai Cab';
import Mumbaitopunecabs from './pages/Mumbai to Pune Cabs';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cab';
import Dadartopunecab from './pages/Dadar to Pune Cab';
import Mumbaitopuneonewaycab from './pages/Mumbai to Pune One Way Cab';
import Andheritopunecab from './pages/Andheri to Pune Cab';
import Bandratopunecab from './pages/Bandra to Pune Cab';
import Santacruztopunecab from './pages/Santacruz to Pune Cab';
import Mumbaicentraltopunecab from './pages/Mumbai Central to Pune Cab';
import Borivalitopunecabs from './pages/Borivali to Pune Cab';
import Mumbaitopimprichichwad from './pages/Mumbai to Pimpri Chinchwad Cab';
import Navimumbaitopunecab from './pages/Navi Mumbai to Pune Cab';
import Mumbaiairporttopunecitycab from './pages/Mumbai Airport to Pune City Cab';
import Mumbaitopunedailycabs from './pages/Mumbai to Pune Daily Cab';
import Mumbaitopuneonlinecab from './pages/Mumbai to Pune Online Cab';
import Mumbaipunecabbooking from './pages/Mumbai Pune Cab Booking';
import Jogeshwaritopuneservice from './pages/Jogeshwari to Pune Cab Service';
import Goregaontopunecab from './pages/Goregaon to Pune Cab';
import Kandivalitopunecab from './pages/Kandivali to Pune Cab';
import Vileparletopunecabservice from './pages/Vile Parle to Pune Cab Service';
import Bhanduptopunecab from './pages/Bhandup to Pune Cab';
import Ghatkopartopunecabservice from './pages/Ghatkopar to Pune Cab Service';
import Kurlatopunetaxi from './pages/Kurla to Pune Taxi Service';
import Powaimumbaipunecabservice from './pages/Powai Mumbai Pune Cab Service';
import Chemburtopunecab from './pages/Chembur to Pune Cab';
import Terminal from './pages/Terminal 1,2,3 Mumbai Airport to Pune Cab';
import Thanetopunecabs from './pages/Thane to Pune Cab';
import Vikhrolitopunecabservice from './pages/Vikhroli to Pune Cab Services';
import Mumbaitopuneinnovacrystacab from './pages/Mumbai to Pune Innova Crysta Cab';
import Mumbaiairporttopuneertigaonrent from './pages/Mumbai Airport to Pune Ertiga on Rent';
import Mumbaiairportcarrental from './pages/Mumbai Airport Car Rental';
import Panveltopunecab from './pages/Panvel to Pune Cab';
import Churchgatetopune from './pages/Church Gate to Pune Cab Service';
import Bycullatopunecab from './pages/Byculla to Pune Cab Service';
import Vashitopunecabs from './pages/Vashi to Pune Cab';
import Kharghartopunecab from './pages/Kharghar to Pune Cab';
import Mankhurdtopunecabs from './pages/Mankhurd to Pune Cab';
import Punetomumbaidailycabservice from './pages/Pune Mumbai Daily Cab Service';
import Onewaytaximumbaitopune from './pages/One Way Taxi Mumbai to Pune';
import Innovacrystaonrentinpune from './pages/Innova Crysta on Rent in Pune';
import Ertigacabbookinginpune from './pages/Ertiga Cab Booking in Pune';
import Kiacarenceonrentinpune from './pages/Kia Carens On Rent in Pune';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent in Pune';
import Sedancabsbookinginpune from './pages/Sedan Cabs Booking in Pune';
import Forceurbaniaonrentinpune from './pages/Force Urbania On Rent in Pune';
import Punetooutstationtempo from './pages/Pune to Outstation Tempo Traveller';
import Punetomahabaleshawar from './pages/Pune to Mahabaleshwar Tempo Traveller';
import Punetoalibaugtempo from './pages/Pune to Alibaug Tempo Traveller';
import Punetobhimashankartempotraveller from './pages/Pune to Bhimashankar Tempo Traveller';
import Cabserviceinpune from './pages/Cab Service in Pune';
import Puneto5jyotilingadarshancab from './pages/Pune to 5 Jyotirlinga Darshan Cab';
import CovidResources from './pages/CovidResources';
import Careers from './pages/Careers';
import Holidays from './pages/Holidays';
import ContactButtons from './components/ContactButtons';
import Fortuneronrentinpune from './pages/Fortuner On rent in pune';
import Cabserviceinchakan from './pages/Cab Service In Chakan';
import Mumbaiairporttovimannagarcabs from './pages/Mumbai Airport to Viman Nagar Cab';
import Mumbaiairporttonigdi from './pages/Mumbai Airport to Nigdi Cab';
import Mumbaiairporttochakancab from './pages/Mumbai Airport to Chakan Cab';
import Mumbaitobaner from './pages/Mumbai Airport to Baner Cab';
import Mumbaitohinjewadi from './pages/Mumbai Airport to Hinjewadi Cab';
import MumbaitoBhosari from './pages/Mumbai Airport to Bhosari Cab';
import Mumbaitoalandi from './pages/Mumbai Airport to Alandi Cab';
import Mumbaitodighi from './pages/Mumbai Airport to Dighi Cab';
import Mumbaiairporttopimrichichwad from './pages/Mumbai Airport to Pimpri Cab';
import Mumbaiairporttovishrantwadicab from './pages/Mumbai Airport to Vishrantwadi Cab';
import Mumbaiairporttobhanoricabs from './pages/Mumbai Airport to Dhanori Cab';
import Mumbaitokharadi from './pages/Mumbai Airport to Kharadi Cab';
import Mumbaiairporttochandannagarcab from './pages/Mumbai Airport to Chandannagar Cab';
import Mumbaiairporttowagholicab from './pages/Mumbai Airport to Wagholi Cab';
import Mumbaiairporttowadgaonsheri from './pages/Mumbai Airport to Wadgaon Sheri Cab';
import Mumbaiairporttokalyannagar from './pages/Mumbai Airport to Kalyani Nagar Cab';
import Mumbaiairporttoaundhcab from './pages/Mumbai Airport to Aundh Cab';
import Mumbaitonashikfata from './pages/Mumbai Airport to Nashik Fata Cab';
import Mumbaitovallabh from './pages/Mumbai Airport to Vallabh Nagar Cab';
import Mumbaiairporttopashancab from './pages/Mumbai Airport to Pashan Cab';
import Mumbaiairporttobavdhan from './pages/Mumbai Airport to Bavdhan Cab';
import Mumbaiairporttoravetcab from './pages/Mumbai Airport to Ravet Cab';
import Mumbaiairporttooldsangvicab from './pages/Mumbai Airport to Old Sangvi Cab';
import Mumbainewsanghvi from './pages/Mumbai Airport to New Sangvi Cab';
import Mumbaitowakadcab from './pages/Mumbai Airport to Wakad Cab';
import Mumbaitoawargatecab from './pages/Mumbai Airport to Swargate Cab';
import Mumbaitoshivajinagar from './pages/Mumbai Airport to Shivaji Nagar Cab';
import Mumbaiairporttokatraj from './pages/Mumbai Airport to Katraj Cab';
import Mumbaiairporttolohegaoncab from './pages/Mumbai Airport to Lohegaon Cab';
import Mumbaitochchwad from './pages/Mumbai Airport to Chinchwad Cab';
import Mumbaitokothrudcab from './pages/Mumbai Airport to Kothrud Cab';
import PaymentGateway from './pages/PaymentGateway';
import Mypage from './pages/MyPage';
import React, { useEffect, useState } from "react";
import CaptchaScreen from './components/CaptchaScreen';










function App() {

  const [showCaptcha, setShowCaptcha] = useState(false);  // 🔐 Whether to show CAPTCHA
  const [verified, setVerified] = useState(false);         // ✅ Whether CAPTCHA is passed

  useEffect(() => {
    const current = parseInt(localStorage.getItem("visitCount") || "0"); // get current count
    const updated = current + 1;                                         // increment
    localStorage.setItem("visitCount", updated);                        // save new value

    if (updated >= 10) {
      setShowCaptcha(true);                                             // show CAPTCHA on 6th load
      localStorage.setItem("visitCount", "0");                          // reset counter
    }
  }, []);


  if (showCaptcha && !verified) {
    return <CaptchaScreen onVerified={() => setVerified(true)} />;
  }


  return (
    <Router>
<ContactButtons/>
    <ScrollToTop/>
   
<Header/>

  
      <Routes>
        
        <Route path="/" element={<HeroSection/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/careers" element={<Careers/>} />
        <Route path="/Covid-19-Resources" element={<CovidResources/>} />
        <Route path="/term-condition" element={<TermsConditions/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/our-fleet" element={<Ourfleet/>} />
        <Route path="/booking" element={<Booking/>} />
        <Route path="/holidays" element={<Holidays/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/enquiry" element={<Enquiry/>} />
        <Route path="/services" element={<Service/>} />
        <Route path="/packages" element={<Packages/>} />
        <Route path="/Online-payment" element={<PaymentGateway/>} />
        <Route path="/contact-us" element={<Contact/>} />
        <Route path="/Pune-to-Mumbai-Car-Rental" element={<Punetomumbaicarrental/>} />
   
        {/* <Route path="/Pune-to-Mumbai-Car-Rental" element={<Punetomumbaicarrental />} /> */}
<Route path="/Pune-to-Shirdi-Cab-Booking" element={<Punetoshirdicabbooking />} />
<Route path="/Pune-to-Mahabaleshwar-Cab" element={<Punetomahbaleshwer />} />
<Route path="/Pune-to-Lonavala-Khandala-Cab" element={<Punetolonavala />} />
<Route path="/Pune-to-Mumbai-Airport-Taxi" element={<Punetomumbaiairporttaxi />} />
<Route path="/Pune-to-Adlabs-Imagica-Cab-Booking" element={<Punetoadbabsimagicacab />} />
<Route path="/Best-Cab-Service-For-Matheran" element={<Bestcabservice />} />
<Route path="/Pune-to-Ganpatipule-Cab-Booking" element={<Punetoganpatipule />} />
<Route path="/Pune-to-Pandharpur-Cab-Booking" element={<Punetopandharpur />} />
<Route path="/Pune-to-Jyotirlinga-Tour-Package" element={<Punetojyotilingatourpackages />} />



<Route path="/Pune-to-Ashtavinayak-Darshan-Cab" element={<Punetoashtavinayak />} />
<Route path="/Best-Cab-From-Pune-To-Murud-Janjira" element={<Bestcabfrompune />} />
<Route path="/Pune-to-Alibaug-Affordable-Cab" element={<Punetoalibaugcab />} />
<Route path="/Pune-to-Ajanta-Ellora-Cab" element={<Punetoajantaellora />} />
<Route path="/Pune-to-Aurangabad-Cab-Booking" element={<PunetoAurangabadcabbooking />} />
<Route path="/Pune-to-Sade-Teen-Shakti-Peeth-Cab" element={<Punetosaneteenshaktipeeth />} />
<Route path="/Pune-to-Bhimashankar-Round-Trip" element={<Punetobhimashankarround />} />
<Route path="/Pune-Trimbakeshwar-Best-Cab" element={<Punetrimbeshkerbest />} />
<Route path="/Pune-to-Nashik-And-Igatpuri-Cab" element={<Punetonashikandlgatpuri />} />
<Route path="/Pune-to-Kolhapur-Cab-Booking" element={<Punetokolhapurcab />} />



<Route path="/Pune-to-Satara-Cab-Booking" element={<Punetosataracabbooking />} />
<Route path="/Pune-to-Tarkarli-Malvan-Cab" element={<Punetotarkali />} />
<Route path="/Pune-to-Outstation-Cab" element={<Punetooutstationcab />} />
<Route path="/Pune-to-Goa-Cab-Booking" element={<Punetogoacab />} />
<Route path="/Pune-to-Tuljapur-Cab" element={<Punetotuljapur />} />
<Route path="/Pune-to-Alandi-Dehu-Darshan-Cab" element={<Punetoalandidehu />} />
<Route path="/Pune-to-Wai-Panchgani" element={<Punetowaipanchgani />} />
<Route path="/Pune-to-Saputara-Cab-Booking" element={<Punetosaptara />} />
<Route path="/Pune-to-Nagpur-Cab" element={<Punetonagpurcab />} />
<Route path="/Pune-to-Jalana-Cab" element={<Punetojalanacab />} />


<Route path="/Pune-Cabs-Service" element={<Punecabservice />} />
<Route path="/Pune-Taxi-Hire" element={<Punetaxihire />} />
<Route path="/Pune-Online-Cab-Booking" element={<Puneonlinecabbooking />} />
<Route path="/Best-Cab-Service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Pune-to-Nasik-Cabs" element={<Punetonashikcabs />} />
<Route path="/Pune-to-Mahabaleshwar-Cabs" element={<Punetomahabaleshwer />} />
<Route path="/Pune-to-Lonavala-Cabs" element={<Punetolonavalacabs />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicab />} />
{/* <Route path="/Pune-to-Shirdi-Cab-Fare" element={<PuneToShirdiCabFare />} /> */}
<Route path="/Pune-to-Shirdi-Cab-Package" element={<Punetoshirdicabpackage />} />


<Route path="/Pune-to-Ajanta-Ellora-Tour-Package" element={<Punetoajantaellorapackage />} />
<Route path="/Shirdi-Darshan-Package" element={<Shirdidarshanpackage />} />
<Route path="/Pune-Airport-to-Shirdi-Cab" element={<Puneairporttoshirdicab />} />
<Route path="/Pune-to-Shirdi-Ertiga-Cab" element={<Punetoshirdiertigacabs />} />
<Route path="/Pune-to-Shirdi-Innova-Crysta-Cab" element={<Punetoshirdiinnovacrysta />} />
<Route path="/Pune-to-Lavasa-City-Cabs" element={<Pumetolavasacity />} />
<Route path="/Pune-to-Bhimashankar-Cab" element={<Punetobhimashankarcab />} />
<Route path="/Pune-to-Indore-Cabs" element={<Punetoindorecabs />} />
<Route path="/Pune-to-Konkan-Darshan-Cabs" element={<Punetokonkandarshan />} />
<Route path="/Pune-Cab-Fare" element={<Punecabfare />} />


<Route path="/Pune-Outstation-Cabs" element={<Puneoutstationcabs />} />
<Route path="/Pune-to-Panchgani-Cab-Fare" element={<Punetopanchgani />} />
<Route path="/Pune-to-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternationalairport />} />
<Route path="/Ashtavinayak-Darshan-Cab" element={<Ashtavinayakdarshancab />} />
<Route path="/Pune-to-Goa-Cabs" element={<Punetogoacabs />} />
<Route path="/Pune-Airport-Cabs" element={<Puneairportcabs />} />
<Route path="/Pune-to-Kolhapur-Cab" element={<Punetokolhapur />} />

<Route path="/Tempo-Traveller-On-Rent-in-Pune" element={<Tempotravelleronrentinpune />} />
<Route path="/Urbania-On-Rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Pune-Local-Cab-Service" element={<Punelocalcabservice />} />
<Route path="/Viman-Nagar-Pune-Taxi" element={<Vimannagarpunetaxi />} />

<Route path="/Pune-to-Mumbai-Cabs" element={<Punetomumbaicabs />} />
<Route path="/Pune-to-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
<Route path="/Pune-to-Mumbai-One-Way-Cab" element={<Punetomumbaionewaycab />} />
<Route path="/Pune-Mumbai-Car-Hire" element={<Punetomumbaicarhire />} />
<Route path="/Pune-to-Mumbai-Taxi-Fare" element={<Punetomumbaitaxifare />} />
<Route path="/Pune-to-Mumbai-Online-Cab-Booking" element={<Punetomumbaionlinecab />} />
<Route path="/Pimpri-Chinchwad-to-Mumbai-Cab" element={<Pimprichichwadtomumbaicab />} />
<Route path="/Baner-to-Mumbai-Cabs" element={<Banertomumbaicabs />} />
<Route path="/Hinjewadi-to-Mumbai-Cab" element={<Hinjewaditomumbaicab />} />
<Route path="/Pimple-Saudagar-to-Mumbai-Cab-Service" element={<Pimplesaudagartomumbaicab />} />
<Route path="/Wakad-to-Mumbai-Cab" element={<Wakadtomumbaicab />} />
<Route path="/Hadapsar-to-Mumbai-Cab" element={<Hadapsartomumbaicab />} />
<Route path="/Kalyani-Nagar-to-Mumbai-Taxi" element={<Kalyaninagartomumbai />} />
<Route path="/Koregaon-Park-to-Mumbai-Cab" element={<Koregaonparktomumbaicab />} />
<Route path="/Kothrud-to-Mumbai-Cab" element={<Kothrudtomumbaicab />} />
<Route path="/Kharadi-to-Mumbai-Cab" element={<Kharaditomumbaicab />} />
<Route path="/Shivajinagar-to-Mumbai-Cab" element={<Shivajinagartomumbaicab />} />
<Route path="/Pune-to-Mumbai-Ertiga-Cab" element={<Punetomumbaiertigacab />} />


<Route path="/Pune-to-Mumbai-Innova-Crysta-Cab" element={<Punetomumbaiinnovacrysta />} />
<Route path="/Pune-to-Mumbai-Sedan-Cab" element={<Punetomumbaisedancab />} />
<Route path="/Kondhwa-to-Mumbai-Cab" element={<Konshwatomumbaicab />} />
<Route path="/Viman-Nagar-to-Mumbai-Cabs" element={<Vimannagartomumbaicabs />} />
<Route path="/Katraj-to-Mumbai-Cab-Service" element={<Katrajtomumbaicabservice />} />
<Route path="/Pune-Station-to-Mumbai-Cabs-Service" element={<Punestationtomumbaicabsservice />} />
<Route path="/Boat-Club-Road-to-Mumbai-Cab" element={<Boatclubroadtomumbai />} />
<Route path="/Vishrantwadi-to-Mumbai-Cab" element={<Vishrantwaditomumbaicab />} />
<Route path="/Alandi-to-Mumbai-Cabs-Service" element={<Alanditomumbaicabs />} />
<Route path="/Wagholi-to-Mumbai-Cab" element={<Wagholitomumbaicab />} />


<Route path="/Mumbai-to-Pune-Cabs" element={<Mumbaitopunecabs />} />
<Route path="/Mumbai-Airport-to-Pune-Cab" element={<Mumbaiairporttopunecab />} />
<Route path="/Dadar-to-Pune-Cab" element={<Dadartopunecab />} />
<Route path="/Mumbai-to-Pune-One-Way-Cab" element={<Mumbaitopuneonewaycab />} />
<Route path="/Andheri-to-Pune-Cab" element={<Andheritopunecab />} />
<Route path="/Bandra-to-Pune-Cab" element={<Bandratopunecab />} />
<Route path="/Santacruz-to-Pune-Cab" element={<Santacruztopunecab />} />
<Route path="/Mumbai-Central-to-Pune-Cab" element={<Mumbaicentraltopunecab />} />
<Route path="/Borivali-to-Pune-Cab" element={<Borivalitopunecabs />} />
<Route path="/Mumbai-to-Pimpri-Chinchwad-Cab" element={<Mumbaitopimprichichwad />} />
<Route path="/Navi-Mumbai-to-Pune-Cab" element={<Navimumbaitopunecab />} />
<Route path="/Mumbai-Airport-to-Pune-City-Cab" element={<Mumbaiairporttopunecitycab />} />
<Route path="/Mumbai-to-Pune-Daily-Cab" element={<Mumbaitopunedailycabs />} />
<Route path="/Mumbai-to-Pune-Online-Cab" element={<Mumbaitopuneonlinecab />} />
<Route path="/Mumbai-Pune-Cab-Booking" element={<Mumbaipunecabbooking />} />
<Route path="/Jogeshwari-to-Pune-Cab-Service" element={<Jogeshwaritopuneservice />} />
<Route path="/Goregaon-to-Pune-Cab" element={<Goregaontopunecab />} />
<Route path="/Kandivali-to-Pune-Cab" element={<Kandivalitopunecab />} />
<Route path="/Vile-Parle-to-Pune-Cab-Service" element={<Vileparletopunecabservice />} />



<Route path="/Bhandup-to-Pune-Cab" element={<Bhanduptopunecab />} />
<Route path="/Ghatkopar-to-Pune-Cab-Service" element={<Ghatkopartopunecabservice />} />
<Route path="/Kurla-to-Pune-Taxi-Service" element={<Kurlatopunetaxi />} />
<Route path="/Powai-Mumbai-Pune-Cab-Service" element={<Powaimumbaipunecabservice />} />
<Route path="/Chembur-to-Pune-Cab" element={<Chemburtopunecab />} />
<Route path="/Terminal-1-2-3-Mumbai-Airport-to-Pune-Cab" element={<Terminal />} />
<Route path="/Thane-to-Pune-Cab" element={<Thanetopunecabs />} />
<Route path="/Vikhroli-to-Pune-Cab-Services" element={<Vikhrolitopunecabservice />} />
<Route path="/Mumbai-to-Pune-Innova-Crysta-Cab" element={<Mumbaitopuneinnovacrystacab />} />
<Route path="/Mumbai-Airport-to-Pune-Ertiga-on-Rent" element={<Mumbaiairporttopuneertigaonrent />} />
<Route path="/Mumbai-Airport-Car-Rental" element={<Mumbaiairportcarrental />} />
<Route path="/Panvel-to-Pune-Cab" element={<Panveltopunecab />} />
<Route path="/Church-Gate-to-Pune-Cab-Service" element={<Churchgatetopune />} />
<Route path="/Byculla-to-Pune-Cab-Service" element={<Bycullatopunecab />} />
<Route path="/Vashi-to-Pune-Cab" element={<Vashitopunecabs />} />
<Route path="/Kharghar-to-Pune-Cab" element={<Kharghartopunecab />} />
<Route path="/Mankhurd-to-Pune-Cab" element={<Mankhurdtopunecabs />} />
<Route path="/Pune-Mumbai-Daily-Cab-Service" element={<Punetomumbaidailycabservice />} />
<Route path="/One-Way-Taxi-Mumbai-to-Pune" element={<Onewaytaximumbaitopune />} />
<Route path="/Innova-Crysta-on-Rent-in-Pune" element={<Innovacrystaonrentinpune />} />
<Route path="/Ertiga-Cab-Booking-in-Pune" element={<Ertigacabbookinginpune />} />
<Route path="/Kia-Carens-On-Rent-in-Pune" element={<Kiacarenceonrentinpune />} />
<Route path="/Swift-Dzire-On-Rent-in-Pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Sedan-Cabs-Booking-in-Pune" element={<Sedancabsbookinginpune />} />
<Route path="/Force-Urbania-On-Rent-in-Pune" element={<Forceurbaniaonrentinpune />} />
<Route path="/Pune-to-Outstation-Tempo-Traveller" element={<Punetooutstationtempo />} />
<Route path="/Pune-to-Mahabaleshwar-Tempo-Traveller" element={<Punetomahabaleshawar />} />
<Route path="/Pune-to-Alibaug-Tempo-Traveller" element={<Punetoalibaugtempo />} />
<Route path="/Pune-to-Bhimashankar-Tempo-Traveller" element={<Punetobhimashankartempotraveller />} />
<Route path="/Cab-Service-in-Pune" element={<Cabserviceinpune />} />
<Route path="/Pune-to-5-Jyotirlinga-Darshan-Cab" element={<Puneto5jyotilingadarshancab />} />
<Route path="/Fortuner-On-rent-in-pune" element={<Fortuneronrentinpune />} />
<Route path="/Cab-Service-In-Chakan" element={<Cabserviceinchakan />} />



<Route path="/Mumbai-Airport-to-Viman-Nagar-Cab" element={<Mumbaiairporttovimannagarcabs />} />
<Route path="/Mumbai-Airport-to-Nigdi-Cab" element={<Mumbaiairporttonigdi />} />
<Route path="/Mumbai-Airport-to-Chakan-Cab" element={<Mumbaiairporttochakancab />} />
<Route path="/Mumbai-Airport-to-Baner-Cab" element={<Mumbaitobaner />} />
<Route path="/Mumbai-Airport-to-Hinjewadi-Cab" element={<Mumbaitohinjewadi />} />
<Route path="/Mumbai-Airport-to-Bhosari-Cab" element={<MumbaitoBhosari />} />
<Route path="/Mumbai-Airport-to-Alandi-Cab" element={<Mumbaitoalandi />} />
<Route path="/Mumbai-Airport-to-Dighi-Cab" element={<Mumbaitodighi />} />
<Route path="/Mumbai-Airport-to-Pimpri-Cab" element={<Mumbaiairporttopimrichichwad />} />
<Route path="/Mumbai-Airport-to-Vishrantwadi-Cab" element={<Mumbaiairporttovishrantwadicab />} />
<Route path="/Mumbai-Airport-to-Dhanori-Cab" element={<Mumbaiairporttobhanoricabs />} />
<Route path="/Mumbai-Airport-to-Kharadi-Cab" element={<Mumbaitokharadi />} />
<Route path="/Mumbai-Airport-to-Chandannagar-Cab" element={<Mumbaiairporttochandannagarcab />} />
<Route path="/Mumbai-Airport-to-Wagholi-Cab" element={<Mumbaiairporttowagholicab />} />
<Route path="/Mumbai-Airport-to-Wadgaon-Sheri-Cab" element={<Mumbaiairporttowadgaonsheri />} />
<Route path="/Mumbai-Airport-to-Kalyani-Nagar-Cab" element={<Mumbaiairporttokalyannagar />} />
<Route path="/Mumbai-Airport-to-Aundh-Cab" element={<Mumbaiairporttoaundhcab />} />
<Route path="/Mumbai-Airport-to-Nashik-Fata-Cab" element={<Mumbaitonashikfata />} />
<Route path="/Mumbai-Airport-to-Vallabh-Nagar-Cab" element={<Mumbaitovallabh />} />
<Route path="/Mumbai-Airport-to-Pashan-Cab" element={<Mumbaiairporttopashancab />} />
<Route path="/Mumbai-Airport-to-Bavdhan-Cab" element={<Mumbaiairporttobavdhan />} />
<Route path="/Mumbai-Airport-to-Ravet-Cab" element={<Mumbaiairporttoravetcab />} />
<Route path="/Mumbai-Airport-to-Old-Sangvi-Cab" element={<Mumbaiairporttooldsangvicab />} />
<Route path="/Mumbai-Airport-to-New-Sangvi-Cab" element={<Mumbainewsanghvi />} />
<Route path="/Mumbai-Airport-to-Wakad-Cab" element={<Mumbaitowakadcab />} />
<Route path="/Mumbai-Airport-to-Swargate-Cab" element={<Mumbaitoawargatecab />} />
<Route path="/Mumbai-Airport-to-Shivaji-Nagar-Cab" element={<Mumbaitoshivajinagar />} />
<Route path="/Mumbai-Airport-to-Katraj-Cab" element={<Mumbaiairporttokatraj />} />
<Route path="/Mumbai-Airport-to-Lohegaon-Cab" element={<Mumbaiairporttolohegaoncab />} />
<Route path="/Mumbai-Airport-to-Chinchwad-Cab" element={<Mumbaitochchwad />} />
<Route path="/Mumbai-Airport-to-Kothrud-Cab" element={<Mumbaitokothrudcab />} />

        </Routes>
    
<Footer/>
    </Router>
 

  );
}

export default App;
